import LaunchIcon from '@mui/icons-material/Launch'
import { IconButton, Stack } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { ITableColumn, TableColumnType, TableList } from 'src/components/table'
import { rutaPorCodSistema } from 'src/pages/sistema/RefactorLayout'
import { OperacionLCLSCuentaLimiteAprobado } from 'src/pages/sistema/sistemas/lcls/types/dto'
import { OperacionLCLSLimiteAprobadoFields } from 'src/pages/sistema/sistemas/lcls/types/fields'
import { SistemaTipo } from 'src/types/enum/enum'

interface LimitesLCLSTablaProps {
    limites: OperacionLCLSCuentaLimiteAprobado[]
    loading?: boolean
    error?: boolean
}

function LimitesLCLSTabla({ limites, loading, error }: LimitesLCLSTablaProps) {
    const navigate = useNavigate()

    const columns: ITableColumn[] = [
        { label: 'Nro. Cuenta', value: OperacionLCLSLimiteAprobadoFields.NroCuenta },
        { label: 'Razón Social', value: OperacionLCLSLimiteAprobadoFields.RazonSocial },
        { label: 'Moneda', value: OperacionLCLSLimiteAprobadoFields.Moneda },
        { label: 'Fecha Aprobación', value: OperacionLCLSLimiteAprobadoFields.FechaAprobacion, type: TableColumnType.Date },
        {
            label: 'Concertación',
            value: OperacionLCLSLimiteAprobadoFields.LimiteConcertacion,
            type: TableColumnType.Number,

        },
        {
            label: 'DVP',
            value: OperacionLCLSLimiteAprobadoFields.LimiteDVP,
            type: TableColumnType.Number,

        },
        {
            label: 'FOP',
            value: OperacionLCLSLimiteAprobadoFields.LimiteFOP,
            type: TableColumnType.Number,

        },
        {
            label: 'Operación',
            onRenderCell: (row: OperacionLCLSCuentaLimiteAprobado) => (
                <Stack direction={'row'} alignItems={'center'}>
                    <span># {row[OperacionLCLSLimiteAprobadoFields.IdMensaje]}</span>
                    <IconButton onClick={() => navigate(`/operacion/${rutaPorCodSistema[SistemaTipo.LCLS]}/${row[OperacionLCLSLimiteAprobadoFields.IdMensaje]}`)}>
                        <LaunchIcon />
                    </IconButton>
                </Stack>
            )
        }
    ]

    return <TableList entityList={limites} columns={columns} isLoading={!!loading} error={error} />
}

export default LimitesLCLSTabla
